import { startCase } from "lodash";
import React, { useEffect } from "react";
import { ResolveGroups, ResolveUsers } from "../utils/IdentityAPI";
import { GetIdentityOrganization } from "../utils/ServiceManagerAPI";

export interface IAccessLevel {
    level: number;
    name: string;
}

const AccessRuleRenderer = ({ rule }: { rule: string }) => {
    const [value, setValue] = React.useState(rule);

    const setValueToOrganizationName = async (id, type) => {
        let organization = await GetIdentityOrganization(id);
        setValue(organization.name + " - " + startCase(type));
    };

    const setValueToGroupName = async (id) => {
        let groups = await ResolveGroups([id]);
        if (groups.length > 0) {
            setValue(groups[0].name);
        } else {
            setValue("Group: " + id);
        }
    };

    const setValueToUserName = async (id) => {
        let users = await ResolveUsers([id]);
        if (users.length > 0) {
            setValue(users[0].displayName);
        }
    };

    useEffect(() => {
        if (
            rule.toLocaleLowerCase().endsWith(":staff") ||
            rule.toLocaleLowerCase().endsWith(":guest") ||
            rule.toLocaleLowerCase().endsWith(":student") ||
            rule.toLocaleLowerCase().endsWith(":parent")
        ) {
            setValueToOrganizationName(rule.split(":")[0], rule.split(":")[1]);
        } else if (rule.toLocaleLowerCase().endsWith(":group")) {
            setValueToGroupName(rule.split(":")[0]);
        } else if (rule.toLocaleLowerCase().endsWith(":user")) {
            setValueToUserName(rule.split(":")[0]);
        } else if (rule.toLocaleLowerCase() == "*") {
            setValue("Public");
        }
    }, [rule]);

    return <>{value}</>;
};

export default AccessRuleRenderer;
